<template>
  <div>

               {{locationDisplay}}

  <card class="card-user" id="MyQRCode">
    <img slot="image" src=""/>
    <div class="author">
      <a href="#">
        <img class="avatar border-gray" src="img/logo.png" alt="..."/>
      </a>
      <h3>Scan QR Code</h3>
      <qrcode-vue 
        :size="size" 
        :value="value" 
        id="MyQRCode"
      ></qrcode-vue>
    </div>

    <div class="text-center">
      <h3>Contactless Check In</h3>
    </div>

  </card>

    Change Location

               <select class="form-control" v-model="location" required @change="ChangeLocation();">
                 <template v-for="S in Locations">
                   <option :value="S.id">{{S.Location}}</option>
                 </template>
               </select>

                <!-- <button type="button" class="btn btn-primary" @click="SaveImage()">Download</button> -->

</div>
</template>
<script>


import Card from 'src/components/Cards/Card.vue'
import qrcodeVue from 'qrcode-vue'

import { globalStore } from '../../main.js';
import { db } from '../../main.js';
import domtoimage from 'dom-to-image';


  export default {
    components: {
      Card,
      qrcodeVue
      // QrcodeVue
    },
    data () {
      return {
        size: 100,
        bgColor: '#fff',
        fgColor: '#000',
        value: "https:///www.visity.app",
        CompanyId: '',
        Locations: [],
        location: '',
        locationDisplay: '',
        details: [
          {
            title: '12',
            subTitle: 'Files'
          },
          {
            title: '2GB',
            subTitle: 'Used'
          },
          {
            title: '24,6$',
            subTitle: 'Spent'
          }
        ]
      }
    },
    mounted(){

      console.log("QR Code Mounted");

      this.CompanyId = globalStore.AdminId
      console.log("CompanyId: "+this.CompanyId);

      this.GetLocations();

    },
    methods: {
    ChangeLocation(info){
      console.log("Change Location...");
      console.log("LocationId: "+this.location);

      this.value = "https://walkin.visity.app/initialize?id="+this.location;

      this.Locations.map((info)=>{
        if(info.id == this.location){
          this.locationDisplay = info.Location;
        }
      })


    },
    SaveImage(){

      // domtoimage.toBlob(document.getElementById('MyQRCode'))
      //     .then(function (blob) {
      //         window.saveAs(blob, 'my-node.png');
      //     });

        domtoimage.toJpeg(document.getElementById('MyQRCode'), { quality: 0.95 })
            .then(function (dataUrl) {
                var link = document.createElement('a');
                link.download = 'VisityQRCode.jpeg';
                link.href = dataUrl;
                link.click();
            });


    },
    GetLocations(){

      console.log('Get Locations');
      console.log("CompanyId: "+this.CompanyId)

      //-------- fetch all agents -------
      this.Locations = []

      db.collection('Location')
        .where("CompanyId","==",this.CompanyId)
        .where("Active","==",true)
        .get()
        .then((snap) => {

          // let data = snap.docs;
          // console.log(data);
          snap.docs.forEach(doc => {
            // console.log("Doc is: " + doc.id);


            var Email = "";

            if(doc.data().Email){
              Email = doc.data().Email;
            }

            var LastUpdated = "";

            if(doc.data().LastUpdated){
              LastUpdated = doc.data().LastUpdated;
            }

            this.Locations.push({
              id: doc.id,
              Location: doc.data().Location
            });
          });

          setTimeout(()=>{
            console.log('Locations:',this.Locations.length);
            this.value = "https://walkin.visity.app/initialize?id="+this.Locations[0].id;
            this.location = this.Locations[0].Location;
            this.locationDisplay = this.Locations[0].Location;
          });

        })
        .catch((e) => {
          console.log('Error:', (e));
        });


    },
      getClasses (index) {
        var remainder = index % 3
        if (remainder === 0) {
          return 'col-md-3 col-md-offset-1'
        } else if (remainder === 2) {
          return 'col-md-4'
        } else {
          return 'col-md-3'
        }
      }
    }
  }

</script>
<style>

</style>
